import styled from 'styled-components'
import { color } from '../../../GlobalStyle'

export const Component = styled.button`
  text-transform: capitalize;
  height: ${(props) => (props.size === 'small' ? '30px' : '45px')};
  font-size: ${(props) => (props.size === 'small' ? '9px' : '11px')};
  border-radius: 5px;
  border: 1px solid ${color.brand};
  color: ${color.brand};
  padding: ${(props) => (props.size === 'small' ? '4px 0.5px' : '10px 1px')};

  font-weight: normal;
  position: relative;

  ${(props) =>
    props.invert ? `background:${props.theme.brand}; color:#FFF; font-weight:bold;` : null}

  height:${(props) => props.height};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
`
export const Delete = styled.span`
  font-size: 13px;
  padding: 0px;
  position: absolute;
  right: 0;

  top: 0;
`
